export default "__VITE_ASSET__ByQKnaF___"